var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { key: _vm.updateCardKey, staticClass: "workspace" },
    [
      !_vm.selectedWorkspace
        ? _c("div", { staticClass: "no workspace-card" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("SelectWorkspace")))])
          ])
        : _vm._e(),
      _vm._v(" "),
      !!_vm.selectedWorkspace
        ? _c(
            "div",
            { staticClass: "workspace-info-container" },
            [
              _c("object-main-info", {
                attrs: {
                  fields: _vm.fields,
                  identifier: _vm.cardObjectIdentifier,
                  "identifier-label": _vm.$t("Name"),
                  "editing-data": _vm.editingData,
                  "show-edit-button": !_vm.creatingWorkspace,
                  "card-label": _vm.cardLabel,
                  height: "40%",
                  "expand-card": _vm.editingData,
                  "submit-button-label": _vm.submitButtonLabel,
                  "required-fields-filled": _vm.requiredFieldsAreFilled,
                  isWorkspaceObject: _vm.editingData,
                  showEditActionButtons: ""
                },
                on: {
                  "toggle-edit": _vm.toggleEdit,
                  "save-object": _vm.saveObject,
                  "update-object": _vm.updateWorkspace,
                  "cancel-edit": function($event) {
                    _vm.discardChangesDialogIsOpen = true
                  }
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "buttons-before-edit-slot",
                      fn: function() {
                        return [
                          !_vm.creatingWorkspace
                            ? _c("custom-button", {
                                attrs: {
                                  icon: "mdi-open-in-new",
                                  "icon-size": 13,
                                  height: "20px",
                                  width: "20px",
                                  "button-styling": _vm.buttonStyling
                                },
                                on: { buttonClick: _vm.openWorkspace }
                              })
                            : _vm._e()
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  3899925857
                )
              }),
              _vm._v(" "),
              _c("workspace-specific-info", {
                attrs: {
                  users: _vm.selectedWorkspace.users
                    ? _vm.selectedWorkspace.users
                    : [],
                  companies: _vm.selectedWorkspace.companies
                    ? _vm.selectedWorkspace.companies
                    : [],
                  textGeom: _vm.selectedWorkspace.wp_geo_json,
                  editing: _vm.editingData
                },
                on: {
                  "update-map-data": function($event) {
                    return _vm.updateWorkspaceMap($event)
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("loading-spinner", {
        staticStyle: { position: "absolute" },
        attrs: {
          active: _vm.loading,
          "is-full-page": false,
          color: "var(--app-primary-base)"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      }),
      _vm._v(" "),
      _c("dialog-choice", {
        attrs: {
          isOpen: _vm.saveChangesDialogIsOpen,
          title: _vm.$t("SaveChanges"),
          content: _vm.$t("SaveChangesContent"),
          mainActionLabel: _vm.$t("Confirm"),
          secondaryActionLabel: _vm.$t("Cancel"),
          icon: "mdi-content-save",
          iconColor: "var(--app-primary-base)"
        },
        on: {
          mainAction: _vm.saveObject,
          secondaryAction: function($event) {
            _vm.saveChangesDialogIsOpen = false
          }
        }
      }),
      _vm._v(" "),
      _c("dialog-choice", {
        attrs: {
          isOpen: _vm.discardChangesDialogIsOpen,
          title: _vm.$t("DiscardChanges"),
          content: _vm.$t("ClusterCreationConfirmation"),
          mainActionLabel: _vm.$t("Confirm"),
          secondaryActionLabel: _vm.$t("Cancel"),
          icon: "mdi-delete",
          iconColor: "var(--app-primary-base)"
        },
        on: {
          mainAction: _vm.cancelEdit,
          secondaryAction: function($event) {
            _vm.discardChangesDialogIsOpen = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f3822f1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f3822f1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/Directory/Workspace.vue
// module id = null
// module chunks = 